import { render, staticRenderFns } from "./cirugias_admin.vue?vue&type=template&id=000585e4&scoped=true&"
import script from "./cirugias_admin.vue?vue&type=script&lang=js&"
export * from "./cirugias_admin.vue?vue&type=script&lang=js&"
import style0 from "./cirugias_admin.vue?vue&type=style&index=0&id=000585e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000585e4",
  null
  
)

export default component.exports